import { Routes, Route, Navigate } from 'react-router-dom'
import MainLayout from './layouts/MainLayout'
import Home from './pages/Home'
import Prices from './pages/Prices'
import IndustryChain from './pages/IndustryChain'
import Storage from './pages/Storage'
import SupplyDemand from './pages/SupplyDemand'
import Trade from './pages/Trade'
import Monitoring from './pages/Monitoring'
import Dashboard from './pages/Dashboard'
import AdminLogin from './pages/admin/Login'
import AdminLayout from './layouts/AdminLayout'
import AdminDashboard from './pages/admin/Dashboard'
import IntelligenceRoom from './pages/admin/IntelligenceRoom'
import ValidationPage from './pages/admin/Validation'
import './App.css'

function App() {
  return (
    <Routes>
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="validation" element={<ValidationPage />} />
        <Route path="intelligence" element={<IntelligenceRoom />} />
        <Route path="monitoring" element={<Monitoring />} />
      </Route>

      <Route path="/" element={<Dashboard />} />

      <Route element={<MainLayout />}>
        <Route path="about" element={<Home />} />
        <Route path="prices" element={<Prices />} />
        <Route path="price-trend" element={<Prices />} />
        <Route path="industry-chain" element={<IndustryChain />} />
        <Route path="industry" element={<IndustryChain />} />
        <Route path="storage" element={<Storage />} />
        <Route path="supply-demand" element={<SupplyDemand />} />
        <Route path="trade" element={<Trade />} />
      </Route>
    </Routes>
  )
}

export default App
